import React from "react";
import Badge from "../core/Badge";

const ActiveFiltersPanel = ({ activeFilters, suppressLabel = false, suppressWrapping = false, onFilterClick }) => {
  return (
    <div className={`active-filters min-h-[28px] w-full flex gap-1 ${suppressWrapping ? 'flex-nowrap overflow-hidden' : 'flex-wrap md:flex-nowrap'}`}>
      {!suppressLabel && (
        <p className="font-semibold w-fit whitespace-nowrap shrink-0 text-[14px] text-gray-secondary leading-6">
          Active Filters:
        </p>
      )}
      <div className={`relative flex-1 min-w-0 ${suppressWrapping ? 'w-0' : ''}`}>
        <div className={`active-filters-badges relative flex gap-2 hideScrollBar ${suppressWrapping ? 'flex-nowrap overflow-x-auto whitespace-nowrap' : 'flex-wrap'}`}>
          {activeFilters
            .filter(
              ({ suppressInActiveFiltersPanel }) => !suppressInActiveFiltersPanel
            )
            .map((activeFilter, index) => {
              const { label, delete: removeFilter, noTruncate } = activeFilter;
              return (
                <Badge
                  className={`text-gray-primary ${onFilterClick ? 'cursor-pointer' : ''}`}
                  variant="outline"
                  key={index}
                  onClick={onFilterClick}
                  {...(removeFilter && { onClose: removeFilter })}
                >
                  <span
                    className={noTruncate ? "whitespace-nowrap" : "overflow-hidden text-ellipsis whitespace-nowrap block max-w-[200px]"}
                    title={label}
                  >
                    {label}
                  </span>
                </Badge>
              );
            })}
          {suppressWrapping && (
            <div className="hidden-item-blur sticky right-0 shrink-0 w-8 bg-gradient-to-l from-white to-transparent pointer-events-none" />
          )}
        </div>
      </div>
    </div>
  );
};

export default ActiveFiltersPanel;